import React from 'react';
import ControlsBar from './ControlsBar';
import SearchFilterBar from './SearchFilterBar';
import Icon from '../../../components/AppIcon';

const SearchHeader = ({
  viewMode,
  onViewModeChange,
  resultsCount,
  filters = {},
  categories = [],
  searchQuery = '',
  onSearchChange = () => {},
  onFiltersChange = () => {},
  onSearch = () => {},
  isLoading = false,
}) => {
  return (
    <div className="bg-white border-b border-slate-200 shadow-sm">
      {/* Page intro */}
      <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
          <p className="text-sky-300 text-[11px] font-semibold uppercase tracking-[0.18em] mb-2">
            HireBroker marketplace
          </p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Find properties</h1>
              <p className="text-slate-300 mt-2 max-w-xl text-sm sm:text-base">
                Search rentals, sales, luxury homes, and land — filter by budget, beds, and type.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 text-sm">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/10">
                <Icon name="BadgeCheck" size={14} className="text-emerald-300" />
                Verified agents
              </span>
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/10">
                <Icon name="MapPin" size={14} className="text-sky-300" />
                Local coverage
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <SearchFilterBar
          filters={filters}
          categories={categories}
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          onFiltersChange={onFiltersChange}
          onSearch={onSearch}
          isLoading={isLoading}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 border-t border-slate-100">
        <ControlsBar
          resultsCount={resultsCount}
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
        />
      </div>
    </div>
  );
};

export default SearchHeader;
